import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../utils/axios';

const useIntegrations = () => {
  const [user, setUser] = useState(null);
  const [integrationTypes, setIntegrationTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      // Fetch current user info
      const userResponse = await apiClient.get('/iam/me');
      setUser(userResponse.data);

      // Fetch integration types (needed for the form)
      const typesResponse = await apiClient.get('/integrations/types');
      setIntegrationTypes(typesResponse.data.integration_types || []);
    } catch (err) {
      setError('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const saveIntegration = async (formData, editingIntegration) => {
    const url = editingIntegration 
      ? `/integrations/${editingIntegration.integration_id}`
      : '/integrations/';

    try {
      let response;
      if (editingIntegration) {
        response = await apiClient.put(url, formData);
      } else {
        response = await apiClient.post(url, formData);
      }
      return response.data;
    } catch (err) {
      if (err.response && err.response.data) {
        throw new Error(err.response.data.detail || 'Failed to save integration');
      } else {
        throw new Error('Failed to save integration');
      }
    }
  };

  const clearError = () => setError('');
  const setPageError = (errorMessage) => setError(errorMessage);

  useEffect(() => {
    fetchData();
  }, [navigate]);

  return {
    user,
    integrationTypes,
    loading,
    error,
    saveIntegration,
    clearError,
    setPageError
  };
};

export default useIntegrations;
